
import { createAction } from 'redux-actions'

export const SET_DISCONNECT_MESSAGE = 'SET_DISCONNECT_MESSAGE'
export const RAISE_ERROR = 'RAISE_ERROR'

export const setDisconnectMessage = createAction(SET_DISCONNECT_MESSAGE)
export const raiseError = createAction(RAISE_ERROR)

export const GRACEFUL_EXIT = 'GRACEFUL_EXIT'
export const gracefulExit = createAction(GRACEFUL_EXIT)

const CONFIRM_CLOSE_MESSAGE = 'CONFIRM_CLOSE_MESSAGE'
export const confirmCloseMessage = createAction(CONFIRM_CLOSE_MESSAGE)
